const calculatePercentage = (partialVal, totalVal) => {
  return (100 * partialVal) / totalVal;
};

export default calculatePercentage;
